/* 
 * Export component file to be used on project
*/

import { FilterHeader } from './FilterHeader'
export default FilterHeader
